import { useCurrentUser } from './useCurrentUser';

/**
 * Role-based permission helpers for the app UI.
 *
 * `canMutate` is the high-value gate: `viewer` is read-only, while
 * `owner` / `admin` / `member` may create/edit/delete. The backend now
 * enforces this server-side (viewers are blocked from mutations and grants
 * are honored), so this hook only drives the *UI affordance* — hiding pure
 * create buttons and disabling edit/delete controls for viewers.
 *
 * FOLLOW-UP: fine-grained per-resource grant gating (e.g. a member who has
 * been granted `canApprove` on a specific AP invoice) needs a "my grants"
 * endpoint that doesn't exist yet. Until then we gate purely on role; the
 * server remains the source of truth for grant-level decisions.
 */
export function useCan() {
  const { data: user } = useCurrentUser();
  const role = user?.role;

  // Treat unknown/loading role as read-only so we never flash mutation
  // controls before we know the user can use them.
  const canMutate = role != null && role !== 'viewer';

  return { canMutate, role, isViewer: role === 'viewer' };
}
